var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoStroke(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Stroke / Info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M16.3254 10C16.3254 6.50674 13.4933 3.67462 10 3.67462C6.50674 3.67462 3.67462 6.50674 3.67462 10C3.67462 13.4933 6.50674 16.3254 10 16.3254C13.4933 16.3254 16.3254 13.4933 16.3254 10ZM9.41269 12.7651V9.30873C9.41269 8.98422 9.67549 8.72142 10 8.72142C10.3245 8.72142 10.5873 8.98422 10.5873 9.30873V12.7651C10.5873 13.0896 10.3245 13.3524 10 13.3524C9.67549 13.3524 9.41269 13.0896 9.41269 12.7651ZM10.0952 6.30671C10.5659 6.3544 10.9329 6.75166 10.9329 7.23492C10.9329 7.75032 10.5154 8.16787 10 8.16787C9.51674 8.16787 9.11947 7.80079 9.07178 7.33011L9.06706 7.23492L9.07178 7.13974C9.11947 6.66906 9.51674 6.30198 10 6.30198L10.0952 6.30671ZM17.5 10C17.5 14.1423 14.1423 17.5 10 17.5C5.85772 17.5 2.5 14.1423 2.5 10C2.5 5.85772 5.85772 2.5 10 2.5C14.1423 2.5 17.5 5.85772 17.5 10Z",
    fill: "#0D47A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoStroke);
export default __webpack_public_path__ + "static/media/info-stroke.463f776b5739c9b6f691acdd31ebbf47.svg";
export { ForwardRef as ReactComponent };